import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import ReviewsPage from "@/pages/reviews/ReviewsPage/ReviewsPage";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var Reviews = function Reviews() {
  var data = useFullPageData(PageNamesEnum.PAGE_NAME__Reviews);
  if (!data) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    disableLoader: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true
  }, /*#__PURE__*/React.createElement(ReviewsPage, {
    feedbackList: data.feedback_list || []
  }));
};
export default Reviews;